import { Card } from "primereact/card";
import { Dialog } from "primereact/dialog";
import "./SubvendorDashboard.css";

import { useEffect, useState } from "react";
import { ILogin } from "../../../../models/Login";
import { JVSunEditor } from "../../../../shared/JVSuneditor";
import { Fetch } from "../../../../shared/Fetch";

interface IProps {
  open?: boolean,
  singleData?: any,
  setModel: (prev: { singleData: any, open: boolean }) => void,
  reload: () => void,
  modelData: any
}

export const AccountDetails = (props: IProps) => {
  const [model, setModel] = useState(false);
  const [model2, setModel2] = useState(false);
  const [tableData, setTableData] = useState({ tableData: [] } as { tableData: any[] });

  const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');

  const onHide = () => {
    setModel(false);
    setModel2(false);
  };
  function handleJobDescription() {
    setModel(true);
  };

  const loadTableData = async () => {
    if (loginObj.user_Type === 3 || loginObj.user_Type === 4) {
      setTableData({ tableData: tableData.tableData });
      const repsonse = await Fetch("ResourceVendor_Company_Mast/accountsPersons", "GET", null, null, null);
      if (repsonse) {
        const data: Array<any> = await repsonse.json();
        setTableData({ tableData: loginObj.user_Type === 4 ? data.filter(el => el.account_Person_ID === loginObj.account_Person_ID) : data });
      } else setTableData({ tableData: tableData.tableData });
    }
  };
  //<span className="pi pi-pencil mt-2" style={{ cursor: "pointer" }} onClick={() => props.setModel({ singleData: props.modelData, open: true })}></span>
  useEffect(() => {
    loadTableData();
  }, []);
  return (
    <>
      <Card title={<p className="flex justify-content-between"><span>Account Person Details {loginObj.user_Type === 3 && <span>(<span className="cursor-pointer underline" onClick={() => setModel2(true)} style={{ color: "red" }}>{tableData.tableData.length || 0} Contacts</span>)</span>}</span><span></span></p>} style={{ marginBottom: "20px", backgroundColor: "#0093E9", backgroundImage: "linear-gradient(160deg, #0093E9 0%, #80D0C7 100%)", borderRadius: "10px", padding: "20px", color: "#F0F0F0", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", }}>
        <div style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", }}>
          <p style={{ fontSize: "16px", margin: "10px 0", color: "#F0F0F0" }}>
            <strong style={{ color: "#FFD700" }}>Name :</strong>{" "}
            <span>{tableData.tableData[0]?.account_Person_Name}</span>
          </p>
          <p style={{ fontSize: "16px", margin: "10px 0", color: "#F0F0F0" }}>
            <strong style={{ color: "#FFD700" }}>Email :</strong>{" "}
            <span>{tableData.tableData[0]?.account_Person_Email}</span>
          </p>
          <p style={{ fontSize: "16px", margin: "10px 0", color: "#F0F0F0" }}>
            <strong style={{ color: "#FFD700" }}>Phone :</strong>{" "}
            <span>{tableData.tableData[0]?.account_Person_Cell}</span>
          </p>
          <p style={{ fontSize: "16px", margin: "10px 0", color: "#F0F0F0" }}>
            <strong style={{ color: "#FFD700" }}>Desk Phone :</strong>{" "}
            <span>{tableData.tableData[0]?.account_Person_Desk}</span>
          </p>
          {/* <p style={{ fontSize: "16px", margin: "10px 0", color: "#FFD700", cursor: "pointer", textDecoration: "underline", }} onClick={handleJobDescription}>
                Show Job Description
              </p> */}
        </div>
      </Card>

      <Dialog visible={model2} style={{ width: "50vw", overflowY: "scroll" }} header="Accounts Persons" modal className="p-fluid" onHide={onHide}>
        {tableData.tableData.map((el) => <div style={{ marginBottom: "20px", backgroundColor: "#0093E9", backgroundImage: "linear-gradient(160deg, #0093E9 0%, #80D0C7 100%)", borderRadius: "10px", padding: "20px", color: "#F0F0F0", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", }}>
          <p style={{ fontSize: "16px", margin: "10px 0", color: "#F0F0F0" }}>
            <strong style={{ color: "#FFD700" }}>Name :</strong>{" "}
            <span>{el.account_Person_Name}</span>
          </p>
          <p style={{ fontSize: "16px", margin: "10px 0", color: "#F0F0F0" }}>
            <strong style={{ color: "#FFD700" }}>Email :</strong>{" "}
            <span>{el.account_Person_Email}</span>
          </p>
          <p style={{ fontSize: "16px", margin: "10px 0", color: "#F0F0F0" }}>
            <strong style={{ color: "#FFD700" }}>Phone :</strong>{" "}
            <span>{el.account_Person_Cell}</span>
          </p>
          <p style={{ fontSize: "16px", margin: "10px 0", color: "#F0F0F0" }}>
            <strong style={{ color: "#FFD700" }}>Desk Phone :</strong>{" "}
            <span>{el.account_Person_Desk}</span>
          </p>
        </div>)}
      </Dialog>

      <Dialog visible={model} style={{ width: "65vw" }} header="Job Description" modal className="p-fluid" onHide={onHide}>
        <p style={{ fontSize: "16px", margin: "10px 0", color: "black" }} onClick={handleJobDescription}>
          {<JVSunEditor value={`<p><b>Job Description -</b> \n${""}</p>`} />}
        </p>
      </Dialog>
    </>
  );
}